const jquery = $;

const setTaxonGalleryImagesPosition = () => {
  let sequence = 1;

  $('.taxon-gallery-images-sortable-list').children()
    .each((_, item) => {
      const inputSequence = $(item).find('input[name*="position"]');
      inputSequence.val(sequence++)
    })
}

const handleSetTaxonGalleryImagesSort = () => {
  setTaxonGalleryImagesPosition();
}

const handleSetTaxonGalleryRelatedFields = (e) => {
  if (!e?.target?.classList.contains('taxon-gallery-images-field-related-type-control')) {
    return;
  }
  const $target = $(e.target);
  const $container = $target.closest('.taxon-gallery-images-grouped-controls-row');

  const $redirectToFieldContainer = $container.find('.taxon-gallery-images-field-redirect-to');
  const $relatedToProductFieldContainer = $container.find('.taxon-gallery-images-field-related-to-product');
  const $relatedToRealizationFieldContainer = $container.find('.taxon-gallery-images-field-related-to-realization');
  const $relatedToExtraFieldContainer = $container.find('.taxon-gallery-images-field-related-to-extra');
  const $relatedToExtraField = $relatedToExtraFieldContainer.find('input');
  const $uploadButton = $container.find('.taxon-gallery-images-button-upload');
  const $translationRows = $container.siblings('.taxon-gallery-images-controls-row-translations');

  const relatedType = $target.val();
  if ('product' === relatedType) {
    $relatedToProductFieldContainer.css('display', 'block');
    $relatedToRealizationFieldContainer.css('display', 'none');
    $relatedToExtraFieldContainer.css('display', 'none');
    $relatedToExtraField.val('');
    $redirectToFieldContainer.css('display', 'none');
    $uploadButton.css('display', 'none');
    $translationRows.css('display', 'none');
  } else if ('realization' === relatedType || 'realization_to_product' === relatedType) {
    $relatedToProductFieldContainer.css('display', 'none');
    $relatedToRealizationFieldContainer.css('display', 'block');
    $relatedToExtraFieldContainer.css('display', 'block');
    $relatedToExtraField.val('1');
    $redirectToFieldContainer.css('display', 'none');
    $uploadButton.css('display', 'none');
    $translationRows.css('display', 'none');
  } else {
    $relatedToProductFieldContainer.css('display', 'none');
    $relatedToRealizationFieldContainer.css('display', 'none');
    $relatedToExtraFieldContainer.css('display', 'none');
    $relatedToExtraField.val('');
    $redirectToFieldContainer.css('display', 'block');
    $uploadButton.css('display', 'block');
    $translationRows.css('display', 'block');
  }
}

const handleResetRelatedToExtraOnRelatedRealizationChange = (e) => {
  const $target = $(e.target);
  const $field = $target.closest('.taxon-gallery-images-field-related-to-realization');
  if (!$field[0]) {
    return;
  }
  const $container = $field.closest('.taxon-gallery-images-grouped-controls-row');

  const $relatedToExtraFieldContainer = $container.find('.taxon-gallery-images-field-related-to-extra input');
  $relatedToExtraFieldContainer.val('1');
}

const handleTaxonGalleryImageEnabledFieldClick = (e) => {
  const target = e?.target;
  if (target?.classList?.contains('taxon-gallery-images-button-enabled')) {
    handleTaxonGalleryImageEnabledField(target);

    return;
  }
  const $target = $(target).closest('.taxon-gallery-images-button-enabled')
  if ($target[0]) {
    handleTaxonGalleryImageEnabledField($target[0]);
  }
}

const handleTaxonGalleryImageEnabledField = (button) => {
  if (!button?.classList?.contains('taxon-gallery-images-button-enabled')) {
    return;
  }
  const $target = $(button);
  const $input = $(document.getElementById($target.data('input-id')))

  if (true === $input.prop('checked')) {
    $input.prop('checked', false);
    $target.removeClass('checkbox-on-color');
    $target.addClass('checkbox-off-color');
    $target.find('.icon').removeClass('on').addClass('off');

    // move inactive column to the end of images list
    const $column = $target.closest('.column')
    const columnId = String($column.data('id'));
    if (columnId && sortableImages) {
      const currentOrder = sortableImages.toArray();

      let newOrder = currentOrder.filter((id) => {
        return id !== columnId;
      })
      newOrder.push(columnId)
      sortableImages.sort(newOrder, true)
      handleSetTaxonGalleryImagesSort()
    }
  } else {
    $input.prop('checked', true);
    $target.removeClass('checkbox-off-color');
    $target.addClass('checkbox-on-color');
    $target.find('.icon').removeClass('off').addClass('on');
  }
}

const handleTaxonGalleryDeleteButtonClick = (e) => {
  const target = e?.target;
  const $target = $(target).closest('.taxon-gallery-delete-button')
  let button = null
  if (target?.classList?.contains('taxon-gallery-delete-button')) {
    button = target
  } else if ($target[0]) {
    button = $target[0]
  }

  if (button) {
    $('#taxon-gallery-delete-form').submit()
  }
}

const handleSetTaxonGalleryRelatedFieldsInAddedColumn = (e, column) => {
  const $relatedTypeControl = $(column).find('.taxon-gallery-images-field-related-type-control')

  if ($relatedTypeControl[0]) {
    handleSetTaxonGalleryRelatedFields({target: $relatedTypeControl[0]})
  }
}

const handleMenuTabChangeClick = (e) => {
  if (!e.target.classList.contains('taxon-galleries-modal-menu-tab-item') && !e.target.classList.contains('taxon-galleries-modal-menu-view-configuration-group-positions-menu-tab-item')) {
    return
  }
  const $target = $(e.target);
  const currentViewConfigurationType = $target.data('type');
  const currentGroupType = $target.data('group');
  const $form = $('.taxon-galleries-form');
  const action = $form.attr('action');
  $form.attr('action', action.replace(/\/gallery\/[^\/]+\/[^\/]+\/edit\//, `/gallery/${currentViewConfigurationType}/${currentGroupType}/edit/`));

  const $newButton = $form.closest('.ui.modal').find('.taxon-gallery-new-button');
  const href = $newButton.attr('href');
  $newButton.attr('href', href.replace(/\/gallery\/[^\/]+\/[^\/]+\/edit\//, `/gallery/${currentViewConfigurationType}/${currentGroupType}/edit/`))

  if (e.target.classList.contains('taxon-galleries-modal-menu-view-configuration-group-positions-menu-tab-item')) {
    updateCounter($target);
  }
}

const getCurrentSecondaryTabSetting = () => {
  const $newButton = $('.taxon-gallery-new-button');
  const href = $newButton.attr('href');
  const match = href.match(/\/gallery\/[^\/]+\/([^\/]+)\/edit\//);

  return match[1] || null;
};

const handleViewConfigurationEnabledToggled = (e) => {
  const $target = $(e.target);
  if ($target.closest('.taxon-galleries-modal-menu-view-configuration-form-field-enabled').length < 1) {
    return
  }

  const $tab = $target.closest('.tab');
  const $menu = $tab.siblings('.tabular.menu');
  const $tabHeader = $menu.find('.taxon-galleries-modal-menu-view-configuration-group-positions-menu-tab-item.active');
  $tabHeader.data('active', $tabHeader.data('active') + (e.target.checked ? 1 : -1))
  updateCounter($tabHeader)
}

const updateCounter = ($tab) => {
  const $counter = $('.taxon-galleries-counter')

  $counter.text(`${$tab.data('active')}/${$tab.data('total')}`)
}

let savedScrollOffset = 0
const handleMenuElementScrolled = (e) => {
  savedScrollOffset = e.target.scrollTop
}

let sortableImages = null;
$.fn.extend({
  initTaxonGalleryManagement() {
    const $activeMenu = $('.taxon-galleries-modal-menu-inner-container .tab.active .tab.active .taxon-galleries-modal-menu-items')
    if (savedScrollOffset > 0 && $activeMenu.length > 0) {
      $activeMenu[0].scrollTop = savedScrollOffset
    }

    $('.taxon-galleries-modal-menu-inner-container')
      .each((_, container) => {
        const $container = $(container);
        $container
          .find('.menu .item')
          .tab({
            context: $container,
            onVisible: (tabPath) => {
              const currentSecondaryTabSetting = getCurrentSecondaryTabSetting();
              const desiredPath = `${tabPath}/${currentSecondaryTabSetting}`;
              const shouldSwitchSecondaryTab = !tabPath.includes('/') && currentSecondaryTabSetting !== null;
              const $tabs = $container
                .find('.taxon-galleries-modal-menu-tab-item.active')
                .closest('.tabular.menu')
                .siblings('.tab.active')
                .find('.taxon-galleries-modal-menu-view-configuration-group-positions-menu-tab-item');

              setTimeout(() => {
                $tabs.each((_, tab) => {
                  const $tab = $(tab);
                  if (shouldSwitchSecondaryTab) {
                    $tabs.tab('change tab', desiredPath)
                    if ($tab.data('tab') === desiredPath) {
                      $tab.addClass('active');
                    } else {
                      $tab.removeClass('active');
                    }
                  }

                  if ($tab.hasClass('active')) {
                    handleMenuTabChangeClick({target: tab})
                  }
                })
              }, 0)
            }
          });
      })

    handleSetTaxonGalleryImagesSort()
    handleSetTaxonGalleryRelatedFields()
    $('.taxon-gallery-images-button-enabled').each(handleTaxonGalleryImageEnabledField);

    $(document).off('collection-form-add', handleSetTaxonGalleryRelatedFieldsInAddedColumn);
    $(document).off('collection-form-add', handleSetTaxonGalleryImagesSort);
    $(document).off('collection-form-delete', handleSetTaxonGalleryImagesSort);
    $(document).off('change', handleSetTaxonGalleryRelatedFields);
    $(document).off('change', handleResetRelatedToExtraOnRelatedRealizationChange);
    $(document).off('click', handleTaxonGalleryImageEnabledFieldClick);
    $(document).off('click', handleMenuTabChangeClick);
    $(document).off('click', handleTaxonGalleryDeleteButtonClick);
    $(document).off('change', handleViewConfigurationEnabledToggled);

    const sortableLists = document.querySelectorAll('.taxon-gallery-images-sortable-list');
    if (sortableLists) {
      $(document).on('collection-form-add', handleSetTaxonGalleryRelatedFieldsInAddedColumn);
      $(document).on('collection-form-add', handleSetTaxonGalleryImagesSort);
      $(document).on('collection-form-delete', handleSetTaxonGalleryImagesSort);
      $(document).on('change', handleSetTaxonGalleryRelatedFields);
      $(document).on('change', handleResetRelatedToExtraOnRelatedRealizationChange);
      $(document).on('click', handleTaxonGalleryImageEnabledFieldClick);
      $('.taxon-galleries-modal-menu-inner-container .taxon-galleries-modal-menu-items')
        .on('scroll', handleMenuElementScrolled)
    }
    $(document).on('click', handleMenuTabChangeClick);
    $(document).on('click', handleTaxonGalleryDeleteButtonClick);
    $(document).on('change', handleViewConfigurationEnabledToggled);

    sortableImages = sortableLists?.[0] ?
      Sortable.create(sortableLists[0], {
        onEnd: handleSetTaxonGalleryImagesSort
      }) :
      null;
  },
});

jquery(document).ready(() => {
  jquery(document).initTaxonGalleryManagement();
});
